import { render, staticRenderFns } from "./order-setting-flow.vue?vue&type=template&id=1dfce034&scoped=true&"
import script from "./order-setting-flow.vue?vue&type=script&lang=js&"
export * from "./order-setting-flow.vue?vue&type=script&lang=js&"
import style0 from "./order-setting-flow.vue?vue&type=style&index=0&id=1dfce034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfce034",
  null
  
)

export default component.exports